import { useEffect, type ReactNode } from 'react';
import { setMonitoringIdentity } from '@/lib/monitoring';
import { useAuthStore } from '@/stores/authStore';
import { useOrgStore } from '@/stores/orgStore';

interface MonitoringScopeProps {
  children: ReactNode;
}

export function MonitoringScope({ children }: MonitoringScopeProps) {
  const userId = useAuthStore((state) => state.user?.id ?? null);
  const organizationId = useOrgStore((state) => state.organization?.id ?? null);
  const role = useOrgStore((state) => state.memberRole ?? null);

  useEffect(() => {
    setMonitoringIdentity({ userId, organizationId, role });
  }, [userId, organizationId, role]);

  return <>{children}</>;
}
